import BrandList from '@/pages/brand/BrandList.vue';
import BrandAdd from '@/pages/brand/BrandAdd.vue';
import BrandModify from '@/pages/brand/BrandModify.vue';
import BannerManage from '@/pages/brand/BannerManage.vue';
import BrandCategory from '@/pages/brand/BrandCategory.vue';
import BrandCategoryMapping from '@/pages/brand/BrandCategoryMapping.vue';
import SellerInfo from '@/pages/brand/SellerInfo.vue';

export default {
	BrandCategory: {
		id: 'BrandCategory',
		title: '브랜드 카테고리 관리',
		heading: '브랜드 카테고리 관리',
		path: '/brand/category/list',
		component: BrandCategory,
	},
	BrandCategoryMapping: {
		id: 'BrandCategoryMapping',
		title: '브랜드 카테고리 맵핑',
		heading: '브랜드 카테고리 맵핑',
		path: '/brand/mapping/:idBrand',
		component: BrandCategoryMapping,
	},
	BrandList: {
		id: 'BrandList',
		title: '브랜드 리스트',
		heading: '브랜드 리스트',
		path: '/brand/list',
		component: BrandList,
	},
	BrandAdd: {
		id: 'BrandAdd',
		title: '신규 브랜드 등록',
		heading: '신규 브랜드 등록',
		path: '/brand/insert-brand',
		component: BrandAdd,
	},
	BannerManage: {
		type: 'v3',
		id: 'BannerManage',
		title: '배너 관리',
		heading: '배너 관리',
		path: '/brand/banner-manage/:idBrand',
		component: BannerManage,
	},
	BrandModify: {
		id: 'BrandModify',
		title: '브랜드 조회/수정',
		heading: '브랜드 조회/수정',
		path: '/brand/:idBrand',
		component: BrandModify,
	},
	SellerInfo: {
		id: 'SellerInfo',
		title: '판매처별 관리',
		heading: '판매처별 관리',
		path: '/seller-info',
		component: SellerInfo,
	},
};
